export default __webpack_public_path__ + "static/media/red.7e3a7d22.svg";